import { PrivateLayoutContextState } from './privateLayoutContext';

export const showMenuSelector = (state: PrivateLayoutContextState) => state.showMenu;
export const isMobileAdaptiveSelector = (state: PrivateLayoutContextState) => state.isMobileAdaptive;
